/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.com>
 */
import 'resources/less/themes/base/pages/standalone/design_gallery.less';

import 'APP_THEME/_common/legacy/core';
import 'APP_THEME/_common/selectboxit/index';

$(function() {
    if (typeof SnapEngage !== 'undefined') {
        $('#custom-design-services').click(function() {
            return SnapEngage.startLink();
        });
    }
    var $productUploadDropdown = $('#upload-product-criteria');
    $productUploadDropdown.selectBoxIt({ autoWidth: false });
    $productUploadDropdown.on('change', function() {
        var href = $(this)
            .find(':selected')
            .data('href');
        $('#upload-product-criteria-button, #designer-upload .image-link').attr('href', href);
    });
});
